'use client'

import { useState } from 'react'
import { ChevronDown } from 'lucide-react'
import { ADAPTIVE_REFERENCES } from '@/data/adaptive-learning'
import { cn } from '@/lib/utils'

export function AdaptiveReferences() {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div className="mx-auto mt-12 max-w-4xl md:mt-16">
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="border-border bg-bg hover:bg-surface flex w-full cursor-pointer items-center justify-between rounded-xl border p-5 text-left transition-colors"
        aria-expanded={isOpen}
        aria-controls={isOpen ? 'adaptive-references-panel' : undefined}
      >
        <span className="font-heading text-ink text-base font-semibold">
          Research References
        </span>
        <ChevronDown
          size={18}
          className={cn(
            'text-hint shrink-0 transition-transform duration-200',
            isOpen && 'rotate-180'
          )}
        />
      </button>

      {isOpen && (
        <div
          id="adaptive-references-panel"
          className="border-border bg-bg mt-2 rounded-xl border p-5"
        >
          <ol className="list-decimal space-y-2 pl-5">
            {ADAPTIVE_REFERENCES.map((ref, i) => (
              <li key={i} className="text-body text-xs leading-relaxed">
                {ref}
              </li>
            ))}
          </ol>
        </div>
      )}
    </div>
  )
}
